module.exports = __webpack_public_path__ + "img/mapletree.bbe7d40.webp";